export default {
  heroTitle: 'Security, kept simple',
  heroBody:
    'Laplace respects connected-system permissions, limits access by workspace boundaries and keeps sources visible under answers.',

  pillarResidencyTitle: 'Delivery options',
  pillarResidencyBody:
    'Cloud, Hybrid and On-Premises are matched to organization requirements.',
  pillarComplianceTitle: 'Contractual requirements',
  pillarComplianceBody:
    'Data-processing and security requirements are documented in the agreement and supporting materials.',
  pillarLlmTitle: 'AI environment control',
  pillarLlmBody:
    'The AI configuration is agreed before launch for the selected delivery model.',
  pillarAccessTitle: 'Rights preserved',
  pillarAccessBody: 'No plugin access means no data in the answer.',
  pillarSourcesTitle: 'Verifiable answers',
  pillarSourcesBody:
    'Answers keep links to the documents, tickets or threads used as context.',
  pillarAuditTitle: 'Action log',
  pillarAuditBody: 'Administrators can see key requests and actions.',

  permissionsEyebrow: 'Access rights',
  permissionsTitle: 'A workspace sees only what its plugin can access',
  permissionsBody:
    'Laplace works within the permissions of the account used to connect the plugin to the workspace.',
  permissionsItem1: 'Access is limited by the connected account role',
  permissionsItem2: 'Closed spaces do not enter the answer context',
  permissionsItem3: 'The plugin and document stay visible under the answer',
  demoCaption: 'One question — two workspaces',
  demoQuestion: 'What changed in the quarterly finance report?',
  demoAllowedBadge: 'Workspace 1 · Finance access',
  demoAllowedAnswer:
    'The report updates revenue, expenses and the margin forecast.',
  demoAllowedSource: 'Plugin: Confluence · Finance',
  demoDeniedBadge: 'Workspace 2 · no Finance access',
  demoDeniedAnswer: 'This workspace plugin cannot see the finance space.',

  ctaTitle: 'Need a closed environment?',
  ctaBody:
    'Let’s discuss your security requirements and the right delivery model.',
  ctaButton: 'Discuss delivery',
}
